// @ts-nocheck

import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import MoneyCollectOutlined from '@ant-design/icons/MoneyCollectOutlined';
import BarcodeOutlined from '@ant-design/icons/BarcodeOutlined';
import CreditCardOutlined from '@ant-design/icons/CreditCardOutlined';
import BookOutlined from '@ant-design/icons/BookOutlined';
import DesktopOutlined from '@ant-design/icons/DesktopOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import FileOutlined from '@ant-design/icons/FileOutlined';
import ExportOutlined from '@ant-design/icons/ExportOutlined';
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined';
import CarOutlined from '@ant-design/icons/CarOutlined';
import KeyOutlined from '@ant-design/icons/KeyOutlined';
import ControlOutlined from '@ant-design/icons/ControlOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import WindowsOutlined from '@ant-design/icons/WindowsOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import AimOutlined from '@ant-design/icons/AimOutlined';
import EnvironmentOutlined from '@ant-design/icons/EnvironmentOutlined';
import IdcardOutlined from '@ant-design/icons/IdcardOutlined';
import UnlockOutlined from '@ant-design/icons/UnlockOutlined';
import ToolOutlined from '@ant-design/icons/ToolOutlined'

export default {
  DashboardOutlined,
AppstoreOutlined,
DatabaseOutlined,
MoneyCollectOutlined,
BarcodeOutlined,
CreditCardOutlined,
BookOutlined,
DesktopOutlined,
DollarOutlined,
FileOutlined,
ExportOutlined,
CloudUploadOutlined,
CarOutlined,
KeyOutlined,
ControlOutlined,
TeamOutlined,
WindowsOutlined,
SettingOutlined,
AimOutlined,
EnvironmentOutlined,
IdcardOutlined,
UnlockOutlined,
ToolOutlined
}
    